import React from 'react'

type CardLayoutProps = {
  children: React.ReactNode
}

const CardLayout: React.FC<CardLayoutProps> = ({ children }) => (
  <div className="flex h-full justify-between items-center">
    {children}
  </div>
)

export default CardLayout
